module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "py-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    staticClass: "pt-3 px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "lg3": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "loading": _vm.companyLoading,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.data.companyId),
      callback: function($$v) {
        _vm.$set(_vm.data, "companyId", $$v)
      },
      expression: "data.companyId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": "",
      "lg9": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.pricingGroups,
      "placeholder": _vm.$lang.placeholders.pricingGroups,
      "multiple": "",
      "clearable": "",
      "items": _vm.mappedGroups,
      "disabled": _vm.mappedGroups.length <= 0,
      "required": "",
      "rules": [_vm.data.pricingGroups.length > 0 || ("" + (_vm.$lang.errors.missingPricingGroups))]
    },
    model: {
      value: (_vm.data.pricingGroups),
      callback: function($$v) {
        _vm.$set(_vm.data, "pricingGroups", $$v)
      },
      expression: "data.pricingGroups"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "py-1 px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "align-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.years,
      "label": _vm.$lang.actions.selectYear,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingYear)); }]
    },
    model: {
      value: (_vm.data.year),
      callback: function($$v) {
        _vm.$set(_vm.data, "year", $$v)
      },
      expression: "data.year"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "clearable": "",
      "items": _vm.months,
      "label": _vm.$lang.actions.selectMonth
    },
    model: {
      value: (_vm.data.month),
      callback: function($$v) {
        _vm.$set(_vm.data, "month", $$v)
      },
      expression: "data.month"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    staticClass: "mb-2 mt-0 mx-2",
    attrs: {
      "color": "primary",
      "disabled": !_vm.valid
    },
    on: {
      "click": function($event) {
        return _vm.fetchInvoicesforCompany()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.labels.search))]), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 mt-0 mx-2",
    attrs: {
      "color": "primary",
      "loading": _vm.overviewloading
    },
    on: {
      "click": function($event) {
        return _vm.openOverview()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.labels.buildOverview))]), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 mt-0 mx-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showBuildModal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.labels.generateInvoice))])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-2 pt-0 px-0 layout row wrap"
  }, [_c('v-spacer'), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-4 pb-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.invoices,
      "search": _vm.search,
      "loading": _vm.invoices.length === 0,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.pricingGroupName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.totalAmount))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showDetails(props.item.id)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.view) + "\n          ")])], 1)]
      }
    }], null, false, 695685986)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.showOverviewModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "992"
    },
    model: {
      value: (_vm.showOverviewModal),
      callback: function($$v) {
        _vm.showOverviewModal = $$v
      },
      expression: "showOverviewModal"
    }
  }, [_c('overview-modal', {
    attrs: {
      "companies": _vm.companies,
      "pricingGroups": _vm.overviewConfig,
      "months": _vm.months,
      "years": _vm.years,
      "selectedMonth": _vm.data.month,
      "selectedYear": _vm.data.year
    },
    on: {
      "close": function($event) {
        _vm.showOverviewModal = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showBuildModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "450"
    },
    model: {
      value: (_vm.showBuildModal),
      callback: function($$v) {
        _vm.showBuildModal = $$v
      },
      expression: "showBuildModal"
    }
  }, [_c('build-modal', {
    attrs: {
      "months": _vm.months,
      "years": _vm.years,
      "selectedMonth": _vm.data.month,
      "selectedYear": _vm.data.year
    },
    on: {
      "close": function($event) {
        _vm.showBuildModal = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.detailsModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "992"
    },
    model: {
      value: (_vm.detailsModal),
      callback: function($$v) {
        _vm.detailsModal = $$v
      },
      expression: "detailsModal"
    }
  }, [_c('details-modal', {
    attrs: {
      "invoiceId": _vm.invoiceId
    },
    on: {
      "close": function($event) {
        _vm.detailsModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1943d330","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoices/Invoices.vue
// module id = 390
// module chunks = 35